import { render, staticRenderFns } from "./Surgery.vue?vue&type=template&id=02927a2a"
import script from "./Surgery.vue?vue&type=script&lang=js"
export * from "./Surgery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports